<template lang='pug'>
  div
    li(class="list-group-item tw-pl-5 tw-py-5" :class="classes.li")
      template(v-if="hasSubmenu")
        a(:href="href") 
          i(:class="icon" class="mr-2")
          span {{label}}
        a(@click.prevent="toggleSubmenu" href="#") 
          i.fa-solid.fa-chevron-down.ml-2(:class="{ 'fa-rotate-180': isOpen }")
        ul.list-unstyled.tw-pl-4(v-show="isOpen" v-if="submenu.length > 0")
          li(v-for="item in submenu" :key="item.key")
            a(:href="item.href" class="text-sm text-white-50 tw-py-2 tw-block")
              i(:class="item.icon" class="mr-2")
              span {{item.label}}
      template(v-else)
        a(:href="href") 
          i(:class="icon" class="mr-2")
          span {{label}}
</template>

<script>
  export default {
    components: {},
    props: {
      icon: String,
      label: String,
      href: String,
      highlighted: String,
      submenu: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      hasSubmenu() {
        return Array.isArray(this.submenu) && this.submenu.length > 0
      },
      normalizedSubmenu() {
        return Array.isArray(this.submenu) ? this.submenu : []
      }
    },
    data:function(){
      return {
        isOpen: false,
        classes:{
          li:{'list-group-item-active': this.highlighted === 'true' ? true : false}
        }
      }
    },
    methods: {
      toggleSubmenu() {
        this.isOpen = !this.isOpen
      }
    }
}
</script>


<style scoped>
  .fa-chevron-down {
    transition: transform 0.3s ease;
  }
</style>